import { render, staticRenderFns } from "./Matching-problem.vue.js?vue&type=template&id=4289e1f1!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Matching-problem.vue?vue&type=template&id=4289e1f1"
import script from "./Matching-problem.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Matching-problem.vue?vue&type=script&lang=js"
export * from "./Matching-problem.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Matching-problem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports